export default __webpack_public_path__ + "static/media/iUSD+ new2.e3a830c2.png";